import { z } from 'zod';

export const TargetChannelSchema = z.enum([
    'CUSTOM_REQUEST_CHANNEL',
    'MATERIAL_CHANNEL',
    'TRANSPORT_CHANNEL',
    'TMS_CHANNEL',
    'NO_CHANNEL',
]);

export type TARGET_CHANNEL = z.infer<typeof TargetChannelSchema>;
